<template>
    <div>
        <b-modal
            v-model="showModal" 
            title="Editar Usuário" 
            @shown="onModalShown"
            size="lg"
            hide-footer 
        >
            <el-form 
                :model="payload" 
                ref="userEditForm" 
                label-position="top" 
                status-icon 
                :rules="rules"
            > 
                <el-row :gutter="12">
                    <!-- Usuario ativo -->
                    <el-col>
                        <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                <el-button :type="payload.status ? 'success': 'danger'" plain circle :style="{ pointerEvents: 'none' }">
                                    <i class="fas fa-user-lock"></i>
                                </el-button>
                                <h6 class="mb-0 font-weight-bold">Usuário {{ payload.status ? 'Ativo' : 'Inativo' }}</h6>
                            </div>

                            <el-form-item prop="status" class="mb-0">
                                <el-switch 
                                    v-model="payload.status" 
                                    :disabled="isLoading"
                                    active-text="Ativo"
                                    inactive-text="Inativo"
                                />
                            </el-form-item>
                        </div>
                    </el-col>

                    <!-- Nome -->
                    <el-col :span="12">
                        <el-form-item prop="nome">
                            <label>Nome</label>
                            <el-input
                                v-model="payload.nome" 
                                placeholder="Nome do usuário"
                                :disabled="!isAuthorized"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- E-mail -->
                    <el-col :span="12">
                        <el-form-item prop="email">
                            <label>E-mail</label>
                            <el-input
                                v-model="payload.email" 
                                placeholder="E-mail do usuário"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Perfil do usuario -->

                    <el-col :span="12">
                        <el-form-item prop="tipo_usuario">
                            <label>Perfil do Usuário</label>
                            <el-select
                                v-model="payload.tipo_usuario"
                                placeholder="Perfil do usuário"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="role in roles"
                                    :key="role.tipo"
                                    :label="role.text"
                                    :value="role.tipo"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Representante -->
                    <el-col v-if="representersFiltred.length > 0" :span="12">
                        <el-form-item prop="representante_codigo">
                            <label>{{ representerTitle }}</label>
                            <el-select
                                v-model="payload.representante_codigo"
                                placeholder="Representante"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="representer in representersFiltred"
                                    :key="representer.value"
                                    :label="representer.text"
                                    :value="representer.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Representante para tipo preposto -->
                    <el-col v-if="payload.tipo_usuario === 'preposto'" :span="12">
                        <el-form-item prop="representante_preposto">
                            <label>Representante do Preposto</label>
                            <el-select
                                v-model="payload.representante_preposto"
                                placeholder="Representante"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="representer in representersPrepoFiltred"
                                    :key="representer.value"
                                    :label="representer.text"
                                    :value="representer.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <!-- Centro de Distr -->
                    <el-col v-if="payload.tipo_usuario !== 'preposto'" :span="payload.tipo_usuario === 'representante_varejo' ? 12 : 24">
                        <el-form-item prop="centro_distribuicao">
                            <label>Centro de distribuição</label>
                            <el-select
                                v-model="payload.centro_distribuicao"
                                placeholder="Centro de distribuição"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="center in centers"
                                    :key="center.value"
                                    :label="center.text"
                                    :value="center.codigo"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Cargos -->
                    <el-col v-if="payload.tipo_usuario === 'representante_varejo' && payload.representante_codigo" :span="12">
                        <el-form-item prop="cargo">
                            <label>Cargo</label>
                            <el-select
                                v-model="payload.cargo"
                                placeholder="Cargo"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="cargo in cargos"
                                    :key="cargo"
                                    :label="cargo"
                                    :value="cargo"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Regioes -->
                    <el-col v-if="payload.tipo_usuario === 'gestor' || payload.tipo_usuario === 'representante_varejo'" >
                        <el-form-item>
                            <label>Regiões</label>
                            <el-select 
                                v-model="payload.regioes" 
                                multiple 
                                placeholder="Regiões"
                                :disabled="isLoading"
                                filterable
                            >
                                <el-option
                                    v-for="item in regioes"
                                    :key="item.value"
                                    :label="item.uf"
                                    :value="item.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Regional Farma -->
                    <el-col v-if="payload.tipo_usuario === 'gerente_regional'">
                        <el-form-item prop="regional_farma">
                            <label>Regional Farma</label>
                            <el-select
                                v-model="payload.regional_farma"
                                placeholder="Selecione a regional"
                                :disabled="isLoading"
                            >
                                <el-option
                                    v-for="regional in regionaisFarma"
                                    :key="regional"
                                    :label="regional"
                                    :value="regional"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Classes atendidas -->
                    <el-col>
                        <el-form-item prop="classes_atendidas">
                            <label>Classes atendidas</label>
                            <el-select
                                v-model="payload.classes_atendidas"
                                multiple
                                placeholder="Todas as classes"
                                :disabled="isLoading"
                                clearable
                            >
                                <el-option
                                    v-for="classe in classesDistribuidor"
                                    :key="classe.value"
                                    :label="classe.label"
                                    :value="classe.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Regiao da retencao (meta fixa na tela de Retencao) -->
                    <el-col>
                        <el-form-item prop="regiao_retencao">
                            <label>Região da retenção</label>
                            <el-select
                                v-model="payload.regiao_retencao"
                                placeholder="Nenhuma (vê todas)"
                                :disabled="isLoading"
                                clearable
                            >
                                <el-option
                                    v-for="regiao in regioesRetencao"
                                    :key="regiao"
                                    :label="'Região ' + regiao"
                                    :value="regiao"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    type="danger"
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    :disabled="isLoading || userId == null"
                                    @click="onSubmit"
                                >
                                    Salvar
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </b-modal>
    </div>
</template>
<script>
    // Components
    import {
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Card,
        Empty,
        Notification,
        Form, 
        FormItem,
        Select,
        Option,
        Switch,
    } from "element-ui";

    // Schema
    import { validateEmail, validatePass, validateMatchPass } from "@/schemas/generalSchema"
    import { validateRepresenter, validateRepresenterPrepo } from "@/schemas/userSchema"

    //Api
    import { UserApi } from "@/api/User/UserApi";
    import { CentroDistribuicaoApi } from "@/api/CentroDistribuicaoApi";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi";

    const userApi = new UserApi();
    const centroDistApi = new CentroDistribuicaoApi();
    const generalResourcesApi = new GeneralResourcesApi();

    const TIPOS_USUARIOS_POR_REPRESENTANTE = {
        representante: ['representante_varejo', 'gerente_regional', 'gerente_distrital', 'analista_farma'],
        gestor: ['gestor'],
        preposto: ['preposto'],
        gerente: ['gerente_varejo', 'gerente_nacional', 'diretor_nacional']
    }

    const CLASSES_DISTRIBUIDOR = [
        { value: 'G', label: 'Classe Gestora' },
        { value: 'A', label: 'Classe Master' },
        { value: 'V', label: 'Classe Varejo' },
        { value: 'L', label: 'Classe L' },
        { value: 'F', label: 'Classe Farma' },
        { value: 'J', label: 'Classe J' },
        { value: 'P', label: 'Classe P' },
    ]

    const REGIONAIS_FARMA = ['SP', 'RJ/ES/CO', 'MG/MT', 'N/NE', 'RS/SC/MS/PR']

    export default { 
        data() {
            return {
                isInitializing: false,
                userId: null,
                payload: {
                    nome: null,
                    email: null,
                    regioes: [],
                    classes_atendidas: [],
                    regional_farma: null,
                    regiao_retencao: null,
                    status: false,
                    tipo_usuario: "",
                    centro_distribuicao: null,
                    cargo: null,
                    representante_codigo: null,
                    representante_preposto: null,
                },
                showModal: false,
                isLoading: false,
                roles: [],
                centers: [],
                representers: [],
                regioes: [],
                classesDistribuidor: CLASSES_DISTRIBUIDOR,
                regionaisFarma: REGIONAIS_FARMA,
                regioesRetencao: ['1', '2', '3', '4', '5', '6', '7'],
                cargos: [
                    "GERENTE NACIONAL",
                    "GERENTE DIVISIONAL",
                    "GERENTE DISTRITAL",
                    "PROMOTORA",
                ],
                rules: {
                    nome: [
                        { required: true, message: 'O nome é obrigatório' }
                    ],
                    email: [
                        { required: true, message: 'O email é obrigatório' },
                    ],
                    tipo_usuario: [
                        { required: true, message: 'É necessário selecionar um perfil' }
                    ],
                    regional_farma: [
                        { required: true, message: 'Selecione a regional' }
                    ],
                    representante_codigo: [],
                    representante_preposto: [],
                    centro_distribuicao: [
                        { required: true, message: 'É necessário selecionar um centro de distribuição' },
                    ],
                },
            }
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole'](['adm']);
            },
            tiposRepresentantePermitidos() {
                return Object.entries(TIPOS_USUARIOS_POR_REPRESENTANTE)
                    .filter(([, tiposUsuario]) =>
                        tiposUsuario.includes(this.payload.tipo_usuario)
                    )
                    .map(([tipoRepresentante]) => tipoRepresentante)
            },
            representersFiltred() {
                return this.representers.filter(representer =>
                    this.tiposRepresentantePermitidos.includes(representer.tipo)
                )
            },
            representersPrepoFiltred() {
                if (this.payload.tipo_usuario) {
                    return this.representers.filter(representer => representer.tipo == "representante")
                }
                
                return []
            },
            representerTitle() {
                const titles = ['Representante', 'Gestor', 'Preposto', 'Gerente']

                return titles.filter(title =>
                    this.tiposRepresentantePermitidos.includes(title.toLowerCase())
                )[0];
            }
        },  
        methods: {
            async getUser(id) {
                const elLoading = this.$loading({ lock: true })
                try {      
                    this.isLoading = true;
                    this.isInitializing = true;

                    this.userId = id;

                    const res = await userApi.show(id)

                    this.payload.nome = res?.name ?? null;
                    this.payload.email = res?.email ?? null;
                    this.payload.status = res?.status ?? false;
                    this.payload.centro_distribuicao = res?.centro_distribuicao ?? null;
                    this.payload.tipo_usuario = res?.roles[0]?.name ?? null;
                    this.payload.representante_codigo = res?.vendedor?.codigo ?? null;
                    this.payload.representante_preposto = res?.vendedor?.preposto_vendedor?.codigo ?? null;
                    this.payload.cargo = res?.vendedor?.cargo ?? null;
                    this.payload.regioes = res?.regioes?.map((uf) => uf.id) ?? []
                    this.payload.classes_atendidas = res?.classes_atendidas ?? []
                    this.payload.regional_farma = res?.regional_farma ?? null
                    this.payload.regiao_retencao = res?.regiao_retencao ?? null

                    this.$nextTick(() => {
                        this.isInitializing = false;
                    });

                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o usuário!'
                    });
                } finally {
                    this.toggleModal();
                    this.isLoading = false;
                    elLoading.close();
                }
            },
            async onSubmit() {
                this.$refs.userEditForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;

                    await userApi.update(this.payload, this.userId)
                        .then(() => {
                            Notification.success({
                                title: 'Sucesso',
                                message: 'O Usuário atualizado com sucesso!'
                            });
                        }).catch((error) => {
                            if (error?.response.status == 422) {
                                if (error?.response?.data.errors) {
                                    error.response.data.errors.forEach(err_message => {
                                        Notification.warning({
                                            title: 'Atenção',
                                            message: err_message
                                        });
                                    });
                                }
                                return
                            }

                            Notification.error({
                                title: 'Erro',
                                message: 'Não foi possível atualizar o usuário!'
                            });
                        }).finally(() => {
                            this.isLoading = false;
                            this.toggleModal();
                            this.resetForm();
                        });
                })
            },
            async getRoles() {
                try {
                    const res = await userApi.roles()

                    this.roles = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as funções dos usuários!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async getCenters() {
                try {
                    const res = await centroDistApi.pluck()

                    this.centers = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os centros de distribução!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async getRepresenters(){
                try {
                    const res = await userApi.pluckRepresenters()

                    this.representers = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os representantes!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async getRegioes() {
                try {
                    const res = await userApi.pluckRepresenters()

                    this.regioes = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os representantes!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async getUfs() {
                try {
                    const res = await generalResourcesApi.pluckUfs();

                    this.regioes = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os estados!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.userEditForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.userEditForm.resetFields();
            },
        },
        watch: {
            'payload.tipo_usuario': function (_newValue, _oldValue) {
                if (this.isInitializing) {
                    return;
                }

                if(_newValue !== _oldValue) {
                    this.payload.representante_codigo = null;
                    this.payload.regioes = [];
                    this.payload.regional_farma = null;
                    this.payload.cargo = null;
                    this.payload.representante_preposto = null;
                }

                if(_newValue !== 'representante_varejo') {
                    this.payload.cargo = null;
                }

                if(_newValue === 'preposto') {
                    this.payload.centro_distribuicao = null
                }
            }
        },
        mounted() {
            this.getRoles();
            this.getCenters();
            this.getRepresenters();
            this.getUfs();
        },
        created() {
            this.rules.email.push({ validator: validateEmail(this.payload), trigger: 'blur' })
            this.rules.representante_codigo.push({ validator: validateRepresenter(this.payload), trigger: 'change' })
            this.rules.representante_preposto.push({ validator: validateRepresenterPrepo(this.payload), trigger: 'change' })
        },
        components: {
            [Message.name]: Message,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Dialog.name]: Dialog,
            [Card.name]: Card,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [Switch.name]: Switch,
            [Dialog.name]: Dialog,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/User/UserEditModal.vue